import { UUID } from "../generic/uuid";
import {
  createOrganisationDtoFromOfferOrganisationModel,
  OrganisationModel,
} from "./organisation";
import { SupplierDto } from "@vini-wine/core-dtos";

export interface SupplierModel extends UUID {
  // transform
  name: string;

  // available includes
  organisation?: OrganisationModel;
  supplierOrganisation?: OrganisationModel;
}

export const createSupplierDtoFromOfferSupplierModel = (
  supplier: SupplierModel,
): SupplierDto => {
  return {
    uuid: supplier.uuid,
    name: supplier.name,
    supplierOrganisation: supplier.supplierOrganisation
      ? createOrganisationDtoFromOfferOrganisationModel(
          supplier.supplierOrganisation,
        )
      : undefined,
  };
};
